module.exports = require("@swa-ui/core/src/Ripple/Ripple.module.scss");